import { MenuProps } from "antd";
import {
  TeamOutlined,
  FileDoneOutlined,
  ProfileOutlined,
} from "@ant-design/icons";

import { NavigationPath } from "..";

export const sidebarMenuItems: MenuProps["items"] = [
  {
    label: <div className="lg:text-black opacity-85">Zahtjevi za ponude</div>,
    icon: (
      <div>
        <ProfileOutlined className="text-black opacity-85" />
      </div>
    ),
    key: NavigationPath.OFFER_REQUESTS_ROUTE,
  },
  {
    label: <div className="lg:text-black opacity-85">Odgovori na zahtjeve</div>,
    icon: (
      <div>
        <FileDoneOutlined className="text-black opacity-85" />
      </div>
    ),
    key: NavigationPath.OFFER_RESPONSES_ROUTE,
  },
  {
    label: <div className="lg:text-black opacity-85">Korisnici</div>,
    icon: (
      <div>
        <TeamOutlined className="text-black opacity-85" />
      </div>
    ),
    key: NavigationPath.USERS_ROUTE,
  },
  {
    label: <div className="lg:text-black opacity-85">Osiguranja</div>,
    icon: (
      <div>
        <TeamOutlined className="text-black opacity-85" />
      </div>
    ),
    key: NavigationPath.INSURANCE_ROUTE,
  },
];
